import { render, staticRenderFns } from "./CreateDocuments.vue?vue&type=template&id=2af2d353&"
import script from "./CreateDocuments.vue?vue&type=script&lang=js&"
export * from "./CreateDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocuments.vue?vue&type=style&index=0&id=2af2d353&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports